import isLength from './isLength';


export const stripPhoneNumber = dirtyInput => dirtyInput.replace(/[^\d]/g, '');

export const validatePhoneNumberRule = invalidMessage => (phoneNumber) => {
    if (phoneNumber && !isLength((stripPhoneNumber(phoneNumber)), { min: 10, max: 15 })) {
        return invalidMessage;
    }
    return null;
};

export default validatePhoneNumberRule;
